import styled from 'styled-components';

export default styled.div`
  text-align: right;
  font-weight: 500;
  float: right;
`;
